<!--设置各列数据对应关系-->
<template>
  <div class="page-container">
    <Header></Header>

    <div class="main-layout">
      <div class="sidebar">
        <MenuList></MenuList>
      </div>

      <div class="content">
        <!-- 页面标题 -->
        <div class="page-header">
          <div class="page-title">
            <i class="el-icon-s-data"></i>数据预览与字段设置
          </div>
          <div class="page-description">
            <p>点击下面表格的文字可设为该列名称。不导入的删除列名即可，点击列名可修改。</p>
          </div>
        </div>

        <!-- 操作栏 -->
        <div class="action-bar">
          <div class="action-left">
            <el-button type="primary" plain size="medium" @click="back">
              <i class="el-icon-arrow-left"></i>上一步
            </el-button>
          </div>
          <div class="action-right">
            <el-button type="primary" size="medium" @click="nextStep">
              下一步<i class="el-icon-arrow-right"></i>
            </el-button>
          </div>
        </div>

        <!-- 数据表格 -->
        <div class="table-container">
          <el-table
            ref="dataList"
            :data="dataList"
            style="width: 100%"
            empty-text="这里将会显示数据"
            border
            @header-click="clickHeader"
            :header-cell-style="{background:'#f5f7fa',color:'#606266',fontWeight:'600'}"
            height="500"
            highlight-current-row>
            <el-table-column
              width="100%"
              header-align="center"
              resizable
              align="center"
              :key="index"
              :label="header.label"
              :prop="header.prop"
              v-for="(header,index) in headList">
              <template slot="header" slot-scope="scope">
                <div class="column-title-style">
                  <div class="original-label" v-if="header.label==header.prop">
                    {{header.label}}
                  </div>
                  <div class="custom-label" v-else>
                    <div v-if="header.can_edit==1">
                      <el-tooltip class="item" effect="light" content="允许填表人需要填写或修改本列">
                        <span class="editable-column"><i class="el-icon-edit-outline"></i>{{header.label}}</span>
                      </el-tooltip>
                    </div>
                    <div v-else>
                      <el-tooltip class="item" effect="dark" content="禁止修改和填写">
                        <span>{{header.label}}</span>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <div class="table-tip">
            <i class="el-icon-warning"></i>如果在此界面上看不到任何数据，说明导入错误，请联系客服解决。客服微信 wx34424698
          </div>
        </div>

      </div>
    </div>

    <!-- 数据预览弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      v-dialogDrag
      title="数据预览"
      :visible.sync="selectColumnTitleDialogVisible"
      height="50%"
      width="70%"
      custom-class="custom-dialog">
      <el-form :model="form">
        <div>
          <el-table
            ref="dataList"
            :data="dataList"
            style="width: 100%"
            empty-text="这里将会是填表人填好的数据"
            border
            res
            :header-cell-style="{background:'#f5f7fa',color:'#606266',fontWeight:'600'}"
            height="300">
            <el-table-column
              header-align="center"
              resizable
              align="center"
              :key="index"
              :label="header.label"
              :prop="header.prop"
              v-for="(header,index) in previewDataList">
              <template slot="header" slot-scope="scope">
                <div class="column-title-style">
                  <span class="preview-label">{{header.label}}</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="nextPage">下一步</el-button>
      </div>
    </el-dialog>

    <!--表格名称-->
    <el-dialog
      width="60%"
      :close-on-click-modal="false"
      title="输入表格名称"
      :visible.sync="inputFormNameDialogVisible"
      custom-class="custom-dialog">
      <div class="col-style">
        <el-input v-model="form_name" placeholder="输入表格名称" style="width:100%"></el-input>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="inputFormNameDialogVisible=false">取 消</el-button>
        <el-button type="primary" @click="confrimFormName()">导 入</el-button>
      </div>
    </el-dialog>

    <!--修改表头-->
    <el-dialog
      width="40%"
      :close-on-click-modal="false"
      title="修改列名称"
      :visible.sync="headLabelDialogVisible"
      custom-class="custom-dialog">
      <div class="header-edit-form">
        <div class="form-item">
          <span class="label">数据列名：</span>
          <el-input v-model="currentHeaderContent" placeholder="输入该列的名称"></el-input>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="headLabelDialogVisible=false">取 消</el-button>
        <el-button @click="deleteHeaderInfo()" v-if="currentHeaderContent!==''">删 除</el-button>
        <el-button type="primary" @click="confirmHeaderInfo()">确 定</el-button>
      </div>
    </el-dialog>

    <!--是否输入数据确认窗口-->
    <el-dialog
      width="55%"
      :close-on-click-modal="false"
      title="请选择导入表格的用途"
      :visible.sync="importDataConfirmDialogVisible"
      custom-class="custom-dialog">
      <div class="import-type-selector">
        <div class="type-title">两种用途,请选择一个:</div>
        <el-radio-group v-model="import_type" @change="changeImportType">
          <div class="type-option">
            <el-radio :label="0">
              <span class="radio-label">用空表格收集全部数据</span>
              <span class="radio-desc">填表人需要填写所有列中的数据,任何人均可领表填写.</span>
            </el-radio>
          </div>
          <div class="type-option">
            <el-radio :label="1">
              <span class="radio-label">用有数据的表格收集部分数据</span>
              <span class="radio-desc">填表人只填写部分数据,只有可以领到表的人才可以填写或修改.</span>
            </el-radio>
          </div>
        </el-radio-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeImportSelector">取 消</el-button>
        <el-button type="primary" @click="nextStepToImport()">下一步</el-button>
      </div>
    </el-dialog>

    <!--选择参数匹配模板-->
    <el-dialog
      title="自动填入设置"
      :visible.sync="selectExcelSettingDialogVisible"
      width="40%"
      custom-class="custom-dialog">
      <div class="setting-dialog-content">
        <div class="setting-title">本次导入的Excel与哪次导入的格式是一样的？请选择:</div>
        <div class="setting-select">
          <el-select v-model="selected_settings_index" placeholder="请选择" :popper-append-to-body="false"
            @change="selectSettingChanged()">
            <el-option v-for="(item,index) in excel_settings" :key="item.id" :label="item.query_name" :value="index">
              <span><span style="font-weight: bold;"> {{item.query_name}}</span><span> ({{item.create_time}})</span></span>
            </el-option>
          </el-select>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="selectExcelSettingDialogVisible=false">取 消</el-button>
        <el-button type="primary" @click="matchFields()">立即填入设置</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'
  import '../assets/global.css'
  import tableItem from './tableItem'
  import Utils from '../utils/utils.js'

  export default {
    components: {
      MenuList,
      Header,
      tableItem
    },
    data() {
      return {
        excel_file: '',
        username: '',
        dataList: [],
        oldList: [],

        headList: [],
        headLabelDialogVisible: false,
        selectedHeaderLabel: '',
        selectedHeaderProp: '',
        currentHeaderContent: '',
        selectedColumnIndex: '',

        previewHeaders: [],
        previewDataList: [],

        ImportStructureAndData: false,

        active: 0,
        isCopyFormName: true,
        isCopyFormComment: false,

        startNum: 1,
        endNum: 2,

        startColumnNum: 1,
        endColumnNum: 2,

        headerPreviewData: [],
        form_titles: [],

        form_name: '',
        form_comment: '',

        options: [],
        column_inputed_value: '',
        selectColumnTitleDialogVisible: false,
        selectColumnNameDialogVisible: false,
        inputFormNameDialogVisible: false,

        tableData: [],
        cols: ['', '', '', ''],
        id: '',
        dialogVisible: false,
        searchResultSettingDialogTableVisible: false,
        position: -1,
        selectedExamID: '',
        msg: '',
        configurations: [],
        showPosition: false,

        record: '',

        name_index: 0,
        num_index: 0,
        recordNum: 0,
        columNames: [],
        selectedColumnNames: [],
        newColumnNames: [],
        realColumnNames: [],
        paperScores: [],
        columnCount: 0,
        rowcount: 0,
        dialogFormVisible: false,
        form: {},
        resData: '',
        loadFromMemory: 'memory',

        settingColumnVisible: false,
        currentPaperScore: 0,
        currentColumn: -1,

        previewColumnLables: [],
        previewTableData: [],

        data_type: ['文本', '数字', '日期', '日期及时间', '单选', '多选', '图片', '视频', '定位'],
        is_optional: ['必须填写', '可以填写'],
        column_types: [],
        selectedColumyType: '',
        currentColumnTitle: '',
        currentColumnDescription: '',
        currentColumnSample: '',
        showColumnSample: false,

        previewHeader: [],
        imageSrc: '',
        excel_src_name: '',
        default_image_url: '/checking/images/default_header.png',
        header_image_url: '',
        excel_column_count: 1,
        showRange: false,

        headRange: '',
        previewSuccess: false,

        form_headers: [],
        header_count: 0,

        selectedTypeValue: '',
        dataTypes: [{
            value: '文本',
            label: '可输入任何内容'
          },
          {
            value: '数字',
            label: '只能输入数字'
          }, {
            value: '身份证号',
            label: '只能输身份证号'
          }, {
            value: '手机号',
            label: '只能输手机号'
          }, {
            value: '日期',
            label: 'xxxx年xx月xx日'
          }, {
            value: '年月',
            label: 'xxxx年xx月'
          }, {
            value: '日期时间',
            label: 'xxxx年xx月xx日 xx点xx分'
          }, {
            value: '自动时间',
            label: '自动填入填表时间'
          }, {
            value: '日期范围',
            label: 'xxxx年xx月xx日至xxxx年xx月xx日'
          }, {
            value: '图片',
            label: '上传一张图片'
          }, {
            value: '视频',
            label: '上传一个视频文件'
          }, {
            value: 'Email邮箱',
            label: '电子邮箱地址'
          }, {
            value: '车牌号',
            label: '只能输入车牌'
          }, {
            value: '签名',
            label: '手写签名'
          }
          , {
            value: '定位',
            label: '自动填写填表人位置'
          }
        ],

        importDataConfirmDialogVisible: false,

        is_import_data: '',
        buffered_datalist: [],
        empty_list: [],

        selectedEditTypeValue: '',
        editTypes: [{
            value: '1',
            label: '允许填表人填写或修改'
          },
          {
            value: '0',
            label: '禁止填表人填写或修改'
          }
        ],

        currentHeaderComment: '',

        import_type: '',


        selectExcelSettingDialogVisible: false,
        excel_settings: [],
        selected_settings_index: '',
        selected_settings: '',

        form_id: '',
        form_name: ''

      }
    },
    created() {
      this.username = this.$session.get('USERNAME')
      this.excel_file = this.$route.params.excel_file

      this.form_id = this.$route.params.form_id
      this.form_name = this.$route.params.form_name

      this.loadData()
    },
    methods: {
      loadData() {
        let that = this

        var requestUrl = '/checking/web/_load_preview_data_ai.jsp'

        const load = this.$loading({
          lock: true,
          text: '正在上传数据和解析复杂表头，请耐心等待...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        this.axios.get(requestUrl, {
            params: {
              username: that.username,
              excel_file: that.excel_file
            }
          }).then(function(response) {

            that.headList = response.data.excel_data.HEADERS
            that.dataList = response.data.excel_data.EXCEL_ROWS
            that.oldList = that.dataList

            var totalRowNum = response.data.excel_data.TOTAL_ROW_NUM

            if (totalRowNum > 0) {

              if (that.dataList.length === 0) {
                return
              }

              that.$refs.dataList.doLayout()
            } else {
              that.$message.error('导入数据条数为0，请检查表格是否为空！')
            }

            var firstRowData = that.dataList[0]
            console.log(response.data.excel_data)
            for (var i = 0; i < that.headList.length; i++) {
              var lableValue=firstRowData['第' + i + '列']
              if(!Utils.isEmpty(lableValue)){
                that.headList[i].label =lableValue
              }

            }

            load.close()

          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },

      clickHeader(column, event) {
        console.log(column)

        var pStr = column.property
        var numArr = pStr.match(/\d+/g)
        var indexStr = numArr.join('')
        this.selectedColumnIndex = indexStr

        let prop = column.property
        let label = ''

        for (var i = 0; i < this.headList.length; i++) {
          if (prop === this.headList[i].prop) {
            label = this.headList[i].label
            break
          }
        }

        if (this.headList[i].label === this.headList[i].prop) {
          this.currentHeaderContent = ''
          this.currentHeaderComment = ''
          this.selectedTypeValue = ''
          this.selectedEditTypeValue = ''
        } else {
          this.currentHeaderContent = label
          this.selectedTypeValue = this.headList[i].data_type
          this.selectedEditTypeValue = this.headList[i].can_edit
          this.currentHeaderComment = this.headList[i].comment
        }

        this.selectedHeaderProp = prop

        this.headLabelDialogVisible = true
      },

      handleCellClick(row, column, cell, event) {
        let prop = column.property
        var pos = 0

        for (var i = 0; i < this.headList.length; i++) {
          if (prop === this.headList[i].prop) {
            pos = i
            this.selectedColumnIndex = pos
            break
          }
        }

        let value = row[prop]

        if (Utils.isEmpty(value)) {
          return
        }

        if (this.headList[pos].label === value) {
          this.headList[pos].label = this.headList[pos].prop
          return
        }

        this.headList[pos].label = value

        this.$message.success(prop + '列名已修改为:"' + value + '"，点击列表头文字可设置更多内容。')

        this.$refs.dataList.doLayout()
      },
      confirmHeaderInfo() {
        if (this.currentHeaderContent === '') {
          this.$message.error('请输入列名称')
          return
        }

        for (var i = 0; i < this.headList.length; i++) {
          if (this.selectedHeaderProp === this.headList[i].prop) {
            this.headList[i].label = this.currentHeaderContent
            this.headList[i].data_type = this.selectedTypeValue
            this.headList[i].can_edit = this.selectedEditTypeValue
            this.headList[i].comment = this.currentHeaderComment

            this.$forceUpdate()
            break
          }
        }

        this.headLabelDialogVisible = false
        this.selectedTypeValue = ''
        this.selectedEditTypeValue = ''
        this.currentHeaderComment = ''
      },

      deleteHeaderInfo() {
        this.currentHeaderContent = ''
        this.currentHeaderComment = ''
        this.selectedTypeValue = ''
        this.selectedEditTypeValue = ''

        this.headList[this.selectedColumnIndex].label = this.headList[this.selectedColumnIndex].prop
        this.headLabelDialogVisible = false
      },

      fieldNameIsValid() {
        var isValid = true

        for (var i = 0; i < this.headList.length; i++) {
          var currentLabel = this.headList[i].label
          for (var k = i + 1; k < this.headList.length; k++) {
            if (currentLabel === this.headList[k].label) {
              isValid = false
              this.$message.error('"' + currentLabel + '"列名重复,请点击表头修改列名！')
              break
            }
          }
        }
        return isValid
      },

      getDuplicateFieldName() {
        var dFieldName = ''

        for (var i = 0; i < this.headList.length; i++) {
          var currentLabel = this.headList[i].label
          for (var k = i + 1; k < this.headList.length; k++) {
            if (currentLabel === this.headList[k].label) {
              dFieldName = currentLabel
              break
            }
          }
        }
        return dFieldName
      },

      hasSettingColumnName() {
        var setted = false

        for (var i = 0; i < this.headList.length; i++) {
          if (this.headList[i].prop !== this.headList[i].label) {
            setted = true
            break
          }
        }

        return setted
      },
      nextStep() {
        if (!this.hasSettingColumnName()) {
          this.$message.error('请选择数据列！')
          return
        }

        var duplicateFieldName = this.getDuplicateFieldName()
        if (!Utils.isEmpty(duplicateFieldName)) {
          this.$message.error('"' + duplicateFieldName + '"列名重复,请点击表头修改列名！')
          return
        }

        this.is_import_data = true
        this.ImportStructureAndData = true

        this.showImportPreview()
      },
      confrimImportDataFormName() {
        this.is_import_data = true
        this.ImportStructureAndData = true
        this.showImportPreview()
      },
      confrimNotImportDataFormName() {
        this.is_import_data = false
        this.ImportStructureAndData = false
        this.showImportPreview()
      },
      showImportPreview() {
        this.previewDataList = []
        this.empty_list = []

        this.buffered_datalist = this.dataList
        console.log(this.buffered_datalist)

        for (var i = 0; i < this.headList.length; i++) {
          if (this.headList[i].prop !== this.headList[i].label) {
            let header = {
              prop: this.headList[i].prop,
              label: this.headList[i].label,
              data_type: this.headList[i].data_type,
              can_edit: this.headList[i].can_edit,
              comment: this.headList[i].comment
            }

            this.previewDataList.push(header)
          }

          var cName = this.headList[i].prop
          let emptyItem = {}
          emptyItem[cName] = ''
          this.empty_list.push(emptyItem)
        }

        if (this.is_import_data === false) {
          this.dataList = this.empty_list
        } else {
          this.dataList = this.filterList(this.buffered_datalist, this.previewDataList)
        }

        this.selectColumnTitleDialogVisible = true
      },
      filterList(buffered_datalist, selectHeaderList) {
        let tmpList = []

        for (var i = 0; i < buffered_datalist.length; i++) {
          let row = buffered_datalist[i]

          var tmpstr = ''
          for (var j = 0; j < selectHeaderList.length; j++) {
            var headerName = selectHeaderList[j].prop
            var cellValue = '' + row[headerName]
            cellValue = cellValue.trim()
            tmpstr = tmpstr + cellValue
          }

          if (!Utils.isEmpty(tmpstr)) {
            tmpList.push(row)
          }
        }

        return tmpList
      },
      nextPage() {
        var tmpDataList = JSON.stringify(this.dataList)
        var finalHeaderList = JSON.stringify(this.previewDataList)

        var import_data = '1'

        if (this.ImportStructureAndData) {
          import_data = '1'
        } else {
          import_data = '0'
        }

        this.$router.push({
          name: 'excel_data_import_final_step',
          params: {
            dataList: tmpDataList,
            headList: finalHeaderList,
            import_data: import_data,
            form_id: this.form_id,
            form_name: this.form_name
          }
        })
      },
      preStep() {
        if (this.active > 0) {
          this.active = this.active - 1
        }
      },
      back() {
        this.$router.back()
      },

      cancelPreviewSetting() {
        this.previewColumnLables.length = 0
        this.dialogFormVisible = false
        this.previewTableData.length = 0
      },
      closeDialog() {
        this.showRange = false
        this.selectColumnTitleDialogVisible = false
        this.previewSuccess = false
      },
      convertHeader(label) {
        if (label == null || label === 'null') {
          return ''
        } else {
          return label
        }
      },
      deleteRow(index, dataList) {
        dataList.splice(index, 1)
        this.$forceUpdate()
      },
      checkImportStateChange(checked) {
        if (checked === true) {
          this.dataList = this.filterList(this.buffered_datalist, this.previewDataList)
          this.is_import_data = true
        } else {
          this.dataList = this.empty_list
          this.is_import_data = false
        }

        this.$forceUpdate()
      },
      changeImportType(value) {
        this.dataList = this.oldList
      },
      closeImportSelector() {
        this.dataList = this.oldList
        this.importDataConfirmDialogVisible = false
      },
      clearSettings() {
        for (var l = 0; l < this.newColumnNames.length; l++) {
          this.newColumnNames[l] = ''
        }

        this.$forceUpdate()

        this.$message.success('清除成功！')
      },
      fillExcelSettings() {
        let that = this

        var requestUrl = '/checking/web/_load_excel_setting_list.jsp'
        this.axios.get(requestUrl, {
            params: {
              equipment: that.username
            }
          }).then(function(response) {

            that.excel_settings = response.data.settings

            if (that.excel_settings.length > 0) {
              that.selectExcelSettingDialogVisible = true
            } else {
              that.$alert('您第一次使用需要手工匹配,以后使用就可以选择啦,辛苦您这次选一下！')
            }

          })
          .catch(function(error) {
            console.log(error)
            that.$message(error)
            that.selectExcelSettingDialogVisible = true
          })


      },
      getSelectedColumnSetting(column_name_prop, columnSettingsArray) {
        var tmpObj = ''
        for (var i = 0; i < columnSettingsArray.length; i++) {
          let column = columnSettingsArray[i]
          if (column_name_prop == column.prop) {
            tmpObj = column
            break
          }
        }

        return tmpObj
      },
      matchFields() {
        let array = JSON.parse(this.selected_settings)
        for (var i = 0; i < this.headList.length; i++) {
          var prop = '第' + i + '列'
          let tmpColumn = this.getSelectedColumnSetting(prop, array)

          if (tmpColumn == '') {
            continue
          } else {
            this.headList[i].label = tmpColumn.label
            this.headList[i].data_type = tmpColumn.data_type
            this.headList[i].can_edit = tmpColumn.can_edit
            this.headList[i].comment = tmpColumn.comment
          }
        }

        this.$forceUpdate()

        this.$message.success('匹配完成！为确保匹配正确，请务必人工核对一遍!')
        this.selectExcelSettingDialogVisible = false

      },
      selectSettingChanged() {
        var index = this.selected_settings_index
        this.selected_settings = this.excel_settings[index].settings
      }

    }
  }
</script>

<style scoped>
.page-container {
  min-height: 100vh;
  background: #f5f7fa;
  display: flex;
  flex-direction: column;
}

.main-layout {
  flex: 1;
  display: flex;
}

.sidebar {
  width: 220px;
  background: #fff;
  border-right: 1px solid #e8ecf1;
  flex-shrink: 0;
}

.content {
  flex: 1;
  padding: 20px;
  overflow: auto;
}

/* 页面标题 */
.page-header {
  margin-bottom: 20px;
}

.page-title {
  font-size: 22px;
  color: #303133;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
}

.page-title i {
  color: #1485FB;
}

.page-description {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 6px;
  border-left: 4px solid #1485FB;
}

.page-description p {
  margin: 8px 0;
  color: #555;
  line-height: 1.6;
  font-size: 14px;
}

/* 操作栏 */
.action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 16px 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.action-left,
.action-right {
  display: flex;
  gap: 12px;
}

/* 表格容器 */
.table-container {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.column-title-style {
  display: flex;
  flex-direction: column;
}

.original-label {
  color: #909399;
  font-size: 13px;
  text-decoration: underline;
}

.custom-label {
  font-size: 14px;
}

.editable-column {
  color: #f56c6c;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}

.editable-column i {
  margin-right: 4px;
}

.table-tip {
  margin-top: 12px;
  padding: 12px 16px;
  background: #fef0f0;
  border-radius: 6px;
  border-left: 4px solid #f56c6c;
  color: #f56c6c;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.table-tip i {
  font-size: 16px;
}

/* 弹窗样式 */
::v-deep .custom-dialog .el-dialog__header {
  background: linear-gradient(135deg, #1485FB 0%, #0066CC 100%);
  padding: 16px 20px;
}

::v-deep .custom-dialog .el-dialog__title {
  color: white;
  font-size: 16px;
  font-weight: 500;
}

::v-deep .custom-dialog .el-dialog__headerbtn .el-dialog__close {
  color: white;
}

.col-style {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.header-edit-form {
  padding: 10px 0;
}

.header-edit-form .form-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-edit-form .label {
  white-space: nowrap;
  color: #606266;
  font-size: 14px;
}

.header-edit-form .el-input {
  flex: 1;
}

/* 导入类型选择 */
.import-type-selector {
  padding: 10px 0;
}

.import-type-selector .type-title {
  font-size: 16px;
  color: #303133;
  margin-bottom: 20px;
  font-weight: 500;
}

.import-type-selector .type-option {
  margin: 16px 0;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.import-type-selector .type-option:hover {
  background: #f0f7ff;
}

.import-type-selector .radio-label {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.import-type-selector .radio-desc {
  display: block;
  margin-top: 8px;
  margin-left: 24px;
  font-size: 13px;
  color: #909399;
  line-height: 1.5;
}

/* 设置弹窗 */
.setting-dialog-content {
  padding: 10px 0;
}

.setting-dialog-content .setting-title {
  font-size: 16px;
  color: #303133;
  margin-bottom: 20px;
  font-weight: 500;
}

.setting-dialog-content .setting-select {
  margin-top: 16px;
}

.setting-dialog-content .setting-select .el-select {
  width: 100%;
}

.dialog-footer {
  text-align: center;
}

/* 预览表格列名 */
.preview-label {
  color: #f56c6c;
  font-weight: 600;
}

/* 表格滚动条 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar-track {
  border-radius: 4px;
  background-color: #f5f7fa;
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #c0c4cc;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .sidebar {
    display: none;
  }

  .content {
    padding: 12px;
  }

  .page-title {
    font-size: 20px;
  }

  .action-bar {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }

  .action-left,
  .action-right {
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/excel_data_preview_ai.vue